<template>
  <qc-container title="加盟商信息">

    <div class="edit-box" v-if="detail">
      <div class="eb-title">
        <div>
          基础信息
        </div>
        <div CLASS="ebt-but" @click="editBase" v-if="auditStatus">
          编辑
        </div>
        <div class="ebt-tips" v-else>
          您提交的资料正在审核中，审核通过后可编辑
        </div>
      </div>

      <div class="eb-content">
        <div class="ebc-logo">
          <image-show v-if="detail.logo" :images="[filePath+detail.logo]" :width="200" :height="100"></image-show>
          <div class="img-empty" v-else>
            <i class="el-icon-picture-outline"></i>
          </div>
        </div>
        <div class="ebc-row">
          <div class="ebc-item lh40">
            <div>门店名称：</div>
            <div>{{detail.storeName}}</div>
          </div>
          <div class="ebc-item lh40">
            <div>门店ID：</div>
            <div>{{detail.code}}</div>
          </div>
          <div class="ebc-item lh40">
            <div>门店地址：</div>
            <div>{{detail.address}}</div>
          </div>
          <div class="ebc-item lh40">
            <div>联系电话：</div>
            <div>{{detail.storePhone}}</div>
          </div>
        </div>
      </div>
    </div>


    <div class="edit-box" v-if="detail">
      <div class="eb-title">
        <div>
          门店资质
        </div>
        <div CLASS="ebt-but" @click="editQualifications">
          编辑
        </div>
      </div>

      <div class="eb-content">
        <div class="ebc-row">
          <div class="ebc-item">
            <div>公司名称：</div>
            <div>{{detail.name}}</div>
          </div>
          <div class="ebc-item">
            <div>信用代码：</div>
            <div>{{shopQualifications.creditCode}}</div>
          </div>
          <div class="ebc-item">
            <div>住所：</div>
            <div>{{ shopQualifications.address }}</div>
          </div>
          <div class="ebc-item">
            <div>有效期：</div>
            <div>{{shopQualifications.expireDate}}</div>
          </div>
          <div class="ebc-item">
            <div>营业执照：</div>
            <div class="ebc-pic">
              <image-show v-if="shopQualifications.businessLicense" :images="[filePath+shopQualifications.businessLicense]" :width="200" :height="100"></image-show>
              <div class="img-empty" v-else>
                <i class="el-icon-picture-outline"></i>
              </div>
            </div>
          </div>
          <div class="ebc-item">
            <div>开户许可证：</div>
            <div class="ebc-pic">
              <image-show v-if="shopQualifications.openPermit" :images="[filePath+shopQualifications.openPermit]" :width="200" :height="100"></image-show>
              <div class="img-empty" v-else>
                <i class="el-icon-picture-outline"></i>
              </div>
            </div>
          </div>

          <div class="ebc-sub-title">
            法人信息
          </div>
          <div class="ebc-item">
            <div>法人：</div>
            <div>{{shopQualifications.legalPerson}}</div>
          </div>
          <div class="ebc-item">
            <div>身份证号：</div>
            <div>{{shopQualifications.identity}}</div>
          </div>
          <div class="ebc-item">
            <div>联系人：</div>
            <div>{{shopQualifications.concatName}}</div>
          </div>
          <div class="ebc-item">
            <div>联系号码：</div>
            <div>{{shopQualifications.mobile}}</div>
          </div>
          <div class="ebc-item">
            <div>身份证正面：</div>
            <div class="ebc-pic">
              <image-show v-if="shopQualifications.identityLeft" :images="[filePath+shopQualifications.identityLeft]" :width="200" :height="100"></image-show>
              <div class="img-empty" v-else>
                <i class="el-icon-picture-outline"></i>
              </div>
            </div>
          </div>
          <div class="ebc-item">
            <div>身份证反面：</div>
            <div class="ebc-pic">
              <image-show v-if="shopQualifications.identityRight" :images="[filePath+shopQualifications.identityRight]" :width="200" :height="100"></image-show>
              <div class="img-empty" v-else>
                <i class="el-icon-picture-outline"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    <div class="edit-box" v-if="qrCode">
      <div class="eb-title">
        <div>
          门店二维码
        </div>
      </div>
      <div class="image-box">
        <image-show v-if="qrCode" :images="[filePath+qrCode]" :width="200" :height="200"></image-show>
        <div class="btn-b">
          <download data="" downMessage="您是否要下载门店二维码"></download>
        </div>
      </div>
    </div>-->

    <org-edit-base ref="orgEditBase" @success="editSuccess"></org-edit-base>
    <org-edit-aptitude ref="orgEditAptitude" @success="editSuccess"></org-edit-aptitude>

  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import ImageShow from "@/components/base/image-show.vue";
import OrgEditBase from "@org/shop/op/edit-base.vue";
import OrgEditAptitude from "@org/shop/op/edit-aptitude.vue";
import BButton from "@/components/el/b-button.vue";
import Download from "@/components/upload/download.vue";

export default {
  name: "",
  components: {Download, BButton, OrgEditAptitude, OrgEditBase, ImageShow, QcContainer},
  data() {
    return {
      filePath:this.filePath,
      detail:null,
      auditStatus:true,
      shopQualifications:null,
      qrCode:"",
    }
  },
  mixins: [tableBase],
  methods: {
    editBase(){
      this.$refs.orgEditBase.openDrawer();
    },
    editQualifications(){
      this.$refs.orgEditAptitude.openDrawer();
    },
    findDetail(){
      this.simpleGet("/api/mgr/business/shop/info/detail",null,result=>{
        let data = result.data;
        this.detail = {id:data.id,name:data.name,code:data.code,logo:data.logo,storeName:data.storeName,storePhone:data.storePhone,address:data.address};
        this.shopQualifications = data.shopQualifications;
      })
    },
    findShopAudit(){
      this.simpleGet("/api/mgr/business/shop/info/findShopAudit",null,result=>{
        let data = result.data;

        if($.isNotEmpty(data)){
          this.auditStatus = false;
          this.detail.logo = data.logo;
          this.detail.storeName = data.storeName;
          this.detail.storePhone = data.storePhone;
          this.detail.address = data.address;
        }
      })
    },
    editSuccess(){
      this.findDetail();
      this.findShopAudit();
    },
    getQrCode(){
      this.simplePost("/api/mgr/business/shop/info/getShopQrCode",null,result=>{
        this.qrCode = result.data;
      })
    }
  },
  mounted() {
    this.findDetail();
    this.findShopAudit();
    //this.getQrCode();
  }
}
</script>

<style lang="less" scoped>
.edit-box{
  margin: 10px;
  border: 1px solid #f5f5f5;
  .eb-title{
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    background: #f5f5f5;
    padding: 0 10px;

    .ebt-but{
      color: #409eff;
      cursor: pointer;
    }
    .ebt-but:hover{
      color: #66b1ff;
    }

    .ebt-tips{
      color: #909399;
    }
  }

  .eb-content{
    padding: 10px 20px;
    display: flex;

    .ebc-logo{
      img{
        width: 200px;
        height: 100px;
        border-radius: 5px;
      }
      padding-right: 20px;
    }

    .ebc-row{
      flex: 1;
      display: flex;
      flex-wrap: wrap;

      .ebc-item{
        width: 50%;
        min-height: 40px;
        display: flex;
        align-items: center;
        .ebc-pic{
          img{
            width: 200px;
            height: 100px;
            border-radius: 5px;
          }
        }
      }

      .ebc-sub-title{
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-weight: bold;
        margin-top: 10px;
      }
    }
  }
}

.img-empty{
  width: 200px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dcdfe6;
  i{
    font-size: 30px;
  }
}

.lh40{
  line-height: 40px;
}
.image-box{
  margin: 20px;
  .btn-b{
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
}
</style>
